import { render, staticRenderFns } from "./OrderPaymentTab.vue?vue&type=template&id=cab75a0e&scoped=true"
import script from "./OrderPaymentTab.vue?vue&type=script&lang=js"
export * from "./OrderPaymentTab.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderPaymentTab.vue?vue&type=style&index=0&id=cab75a0e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "cab75a0e",
  "71f8696e"
  
)

export default component.exports